<div class="flex flex-col gap-1 h-screen" *ngIf="selectedBonusEvent.totalOrderCount > 0; else emptyOrder">
  <div class="text-xl p-2 font-bold">Completed Orders ({{ selectedBonusEvent.totalOrderCount }})</div>
  <hr />
  <div class="overflow-y-auto">
    <div class="flex flex-col px-2" *ngFor="let order of selectedBonusEvent.orders">
      <div class="flex text-xl font-bold justify-between mb-2">
        <div class="">{{ order.orderId | orderId }}</div>
        <div class="flex gap-1">
          <img src="/assets/icons/redeem.svg" alt="redeem" />
          {{ order.totalBonusAmount | currencyInPennies: 'USD':'$' }}
        </div>
      </div>
      <a [routerLink]="['/', 'lmo', 'frac', order.fracId, 'home']">
        {{ order.fracName }}
      </a>
      <div class="flex gap-1">
        <img src="/assets/icons/truck-vendor-icon.svg" alt="truck" />
        {{ order.subcarrierName }}
        <span *ngIf="order.subcarrierName">-</span>
        <span class="font-bold">{{ order.carrierName }}</span>
      </div>
      <div class="flex gap-1">
        <img src="/assets/icons/users.svg" alt="user" />
        {{ order.driverName }}
      </div>
      <div class="flex gap-1">
        <img src="/assets/icons/payments.svg" alt="money" />
        <span class="font-bold">{{ order.totalOrderAmount | currencyInPennies: 'USD':'$' | dashIfNothing }}</span>
        incl. bonuses
      </div>
      <div class="font-light">Completed on {{ order.completedAt | date: 'short' }}</div>
      <hr class="my-1" />
    </div>
  </div>
</div>
<ng-template #emptyOrder>
  <div class="flex flex-col gap-1">
    <div class="text-xl p-2 font-bold">No Completed Orders</div>
  </div>
</ng-template>
